<template>
  <div>
    <c-row>
      <c-col cols="12">
        <c-container fluid class="d-flex content-center">
          <c-card class="p-4" style="max-width: 800px">
            <c-card-body>
              <c-row>
                <c-col cols="12" md="6">
                  <modern-monitor v-if="screenshotUrl" :screenshot-url="screenshotUrl" />
                  <img v-else src="/img/logos/koala-large.svg" style="height: 180px" />
                  <h1 class="h4 mt-3">{{ message || defaultMessage }}</h1>
                </c-col>
                <c-col cols="12" md="6" class="px-5 text-left">
                  <add-a-new-site @screenshotUrl="screenshotUrl = $event" @update:message="message = $event" />
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>
        </c-container>
      </c-col>
    </c-row>

    <c-row class="my-2">
      <c-col>
        <c-container fluid class="d-flex content-center">
          <div style="max-width: 800px" class="text-left">
            <a class="float-right pa-5 cursor-pointer" @click="showAddSiteManual = !showAddSiteManual">
              {{ showAddSiteManual ? 'Hide instructions' : 'Or add site manually' }}
            </a>
          </div>
        </c-container>
      </c-col>
    </c-row>

    <c-row class="mt-4">
      <c-col>
        <c-container fluid class="d-flex content-center">
          <div style="max-width: 800px" class="text-left">
            <manually-add-site-instructions v-if="showAddSiteManual" />
          </div>
        </c-container>
      </c-col>
    </c-row>
  </div>
</template>

<script>
import AddANewSite from '../site/add-new-site';
import MacPlus from '@/views/components/plugin-install/MacPlus';
import ModernMonitor from '@/views/components/plugin-install/ModernMonitor';
import ManuallyAddSiteInstructions from '@/views/components/dashboard/ManuallyAddSiteInstructions';

export default {
  name: 'AddNewSite',
  components: {
    AddANewSite,
    MacPlus,
    ModernMonitor,
    ManuallyAddSiteInstructions,
  },
  props: {
    defaultMessage: '',
  },
  data() {
    return {
      message: '',
      showAddSiteManual: false,
      screenshotUrl: '',
    };
  },
  computed: {},
};
</script>
